import styled from "styled-components";

export const TileLink = styled.div`
  position: relative;
  cursor: pointer;
  text-decoration: none;
  flex: 1;
  height: 100%;
  display: flex;

  @media (max-width: 820px) {
    justify-content: flex-start;
  }
`;

export const TileImage = styled.img`
  width: ${({ full }: { full: boolean }) => (full ? "100%" : "80px")};
  height: ${({ full, isAside }: any) =>
    full ? (isAside ? "157px" : "100%") : "106px"};
  object-fit: ${({ full }: { full: boolean }) => (full ? "cover" : "contain")};
`;

export const TileImageWrapper = styled.div`
  overflow: hidden;
  width: ${({ isFeatured }: any) => (isFeatured ? "none" : "191px")};
  height: ${({ isFeatured }: any) => (isFeatured ? "100%" : "107px")};
  background-color: ${({ isFirst, isAside }: any) =>
    isFirst ? "whitesmoke" : isAside ? "white" : "whitesmoke"};
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;

  @media (max-width: 820px) {
    width: ${({ isFeatured }: any) => (isFeatured ? "none" : "150px")};
    height: ${({ isFeatured }: any) => (isFeatured ? "100%" : "107px")};
  }

  &:hover {
    transition: 0.5s;
  }
  &:hover ${TileImage} {
    transition: 0.5s;
    transform: ${({ isFeatured, full }: any) =>
      isFeatured || full ? "" : "scale(1.1)"};
    transition-timing-function: ease-out;
  }
`;

export const PremiumIcon = styled.div`
  border-radius: 50%;
  position: absolute;
  right: ${({ isFeatured, isAside }: any) =>
    isFeatured ? (isAside ? "10px" : "20px") : "10px"};
  bottom: ${({ isFeatured, isAside }: any) =>
    isFeatured ? (isAside ? "15px" : "20px") : "10px"};
`;

export const TileIcon = styled.div`
  height: ${({ isFeatured, isAside }: any) =>
    isFeatured ? (isAside ? "25px" : "40px") : "20px"};
  width: ${({ isFeatured, isAside }: any) =>
    isFeatured ? (isAside ? "25px" : "40px") : "20px"};
  border: 2px solid black;
  border-radius: 50%;
  position: absolute;
  left: ${({ isFeatured, isAside }: any) =>
    isFeatured ? (isAside ? "10px" : "20px") : "10px"};
  bottom: ${({ isFeatured, isAside }: any) =>
    isFeatured ? (isAside ? "15px" : "20px") : "10px"};
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: ${({ icon }: any) => `url(${icon})`};
`;

export const TileIconImg = styled.img`
  height: ${({ isFeatured, isAside }: any) =>
    isFeatured ? (isAside ? "15px" : "25px") : "13px"};
  width: ${({ isFeatured, isAside }: any) =>
    isFeatured ? (isAside ? "15px" : "25px") : "13px"};
  object-fit: contain;
`;

export const MetaWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  justify-content: space-between;
`;

export const MetaData = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-end;

  justify-content: flex-end;
  @media (max-width: 820px) {
    justify-content: center;
    margin-right: 10px;
  }
`;

export const TileDescription = styled.span`
  color: black;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  margin-top: 10px;
  padding-right: 5px;
`;

export const TileMeta = styled.span`
  color: #78787b;
  margin: 5px 0;
  font-size: 13px;
  line-height: 20px;
  font-weight: 300;
  padding-right: 5px;
`;

export const TileWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  padding-bottom: 5px;
  max-width: ${({ isFeatured }: any) => (isFeatured ? "100%" : "191px")};
  max-height: ${({ isAside }: any) => (isAside ? "245px" : "100%")};

  box-sizing: border-box;
  margin-left: ${({ isFeatured }: any) => (isFeatured ? "0px" : "0px")};

  @media (max-width: 820px) {
    max-width: 100%;
    flex-direction: ${({ isFeatured }: any) => (isFeatured ? "column" : "row")};
    margin-bottom: ${({ isFeatured }: any) => (isFeatured ? "5px" : "10px")};
    justify-content: normal;
  }
`;

export const TileCTA = styled.span`
  background-color: white;
  color: ${({ isQuiz }: any) => (isQuiz ? "#1517ac" : "#de1a1a")};
  font-size: 15px;
  padding: 10px 15px;
  align-self: center;
  border: 1px solid ${({ isQuiz }: any) => (isQuiz ? "#1517ac" : "#de1a1a")};
  font-size: ${({ isFeatured }: any) => (isFeatured ? "15px" : "12px")};
  position: absolute;
  bottom: ${({ isFeatured }: any) => (isFeatured ? "10px" : "15%")};
  left: ${({ isFeatured }: any) => (isFeatured ? "0px" : "0")};
  padding: ${({ isFeatured }: any) => (isFeatured ? "10px 15px;" : "5px 8px;")};
  &:hover {
    background-color: ${({ isQuiz }: any) => (isQuiz ? "#1517ac" : "#de1a1a")};
    color: white;
    border: 1px solid ${({ isQuiz }: any) => (isQuiz ? "#1517ac" : "#de1a1a")};
    transition: 0.3s;
    transition-timing-function: ease-out;
  }

  @media (max-width: 820px) {
    bottom: 0px;
    left: 5px;
    font-size: 12px;
    padding: 5px 8px;
    display: none;
  }
`;
